import { login, qrcodeLogin } from "@/api/auth";
import { getStorage, setStorage, removeStorage } from "@/utils/auth";

const user = {
  state: {
    name: getStorage("name"), // 用户姓名
    phone: getStorage("phone"), // 用户手机号
    avatar: getStorage("avatar"), // 用户头像
    token: getStorage("token"), // 登录token
  },

  mutations: {
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
  },

  actions: {
    // 密码登录
    login({ commit }, userInfo) {
      setStorage("loginPhone", userInfo.phone);
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((response) => {
            if (response.code === 0) {
              const data = response.data;
              // 存储TOKEN
              commit("SET_TOKEN", data.token);
              commit("SET_PHONE", data.phone);
              commit("SET_NAME", data.name);
              commit("SET_AVATAR", data.avatar);
              // 将token保存到cookies
              setStorage("token", data.token);
              setStorage("name", data.name);
              setStorage("phone", data.phone);
              setStorage("avatar", data.avatar);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 密码登录
    qrcodeLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        qrcodeLogin(userInfo)
          .then((response) => {
            if (response.code === 0) {
              const data = response.data;
              // 存储TOKEN
              commit("SET_TOKEN", data.token);
              commit("SET_PHONE", data.phone);
              commit("SET_NAME", data.name);
              commit("SET_AVATAR", data.avatar);
              // 将token保存到cookies
              setStorage("token", data.token);
              setStorage("name", data.name);
              setStorage("phone", data.phone);
              setStorage("avatar", data.avatar);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 登出
    Logout({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        commit("SET_PHONE", "");
        commit("SET_NAME", "");
        commit("SET_AVATAR", "");
        removeStorage("token");
        removeStorage("phone");
        removeStorage("name");
        removeStorage("avatar");
        resolve();
      });
    },
  },
};

export default user;
